import { createApp } from 'vue'
import './style.css'
import '@/assets/pill.css'
import App from './App.vue'
import router from './router/routes.js'
import { createPinia } from 'pinia'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Vueform from '@vueform/vueform'
import vueformConfig from './../vueform.config'
import AnimatedCounter from "vue-animated-counter"
import { pinia as authStore } from './stores/auth.js'

// Nach einem Deploy gibt es die Chunks des alten Stands nicht mehr: ein noch offenes Tab bekommt beim Nachladen 404.
// Dann einmal neu laden, um den aktuellen Stand zu holen (höchstens einmal pro Minute, damit keine Reload-Schleife entsteht)
window.addEventListener('vite:preloadError', (event) => {
  let lastReload = 0;
  try { lastReload = Number(sessionStorage.getItem('reloadAfterPreloadError') || 0); } catch (e) { /* ohne Storage einfach neu laden */ }
  if (Date.now() - lastReload < 60000) return;
  try { sessionStorage.setItem('reloadAfterPreloadError', String(Date.now())); } catch (e) { /* ohne Storage einfach neu laden */ }
  event.preventDefault();
  window.location.reload();
});

const pinia = createPinia()

const app = createApp(App)
  .use(router)
  .use(pinia)
  .use(authStore)
  .use(Vueform, vueformConfig);

AOS.init({ once: false });

app.component("AnimatedCounter", AnimatedCounter);

app.mount('#app');
